import { useState } from "react";
import { toast } from "sonner";
import { Textarea } from "@/components/ui/textarea";
import { http, formatApiError } from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import { Panel } from "@/components/admin/PageBits";

export const NotesPanel = ({ requestId, notes, onChanged }) => {
  const [text, setText] = useState("");
  const add = async () => {
    try {
      await http.post(`/admin/requests/${requestId}/notes`, { text });
      setText("");
      onChanged();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <Panel title="Observações internas" testId="notes-panel">
      <Textarea value={text} onChange={(e) => setText(e.target.value)} maxLength={2000} placeholder="Registrar observação (visível apenas para operadores)" className="min-h-[80px] border-white/10 bg-black/30 text-sm text-slate-100" data-testid="note-input" />
      <button disabled={!text.trim()} onClick={add} className="btn-ghost-sm mt-2 disabled:opacity-40" data-testid="note-add-btn">Adicionar observação</button>
      <ul className="mt-4 space-y-3">
        {notes.map((n) => (
          <li key={n.id} className="border-l-2 pl-3" style={{ borderColor: "var(--brand)" }} data-testid={`note-${n.id}`}>
            <p className="whitespace-pre-line text-sm text-slate-200">{n.text}</p>
            <p className="mt-1 text-xs text-slate-500">{n.operator?.name} · {formatDateTime(n.at)}</p>
          </li>
        ))}
      </ul>
    </Panel>
  );
};

export const HistoryPanel = ({ history }) => (
  <Panel title="Histórico do atendimento" testId="history-panel">
    <ol className="relative space-y-4 border-l border-white/10 pl-5">
      {history.map((h) => (
        <li key={h.id} className="relative" data-testid={`history-${h.action}`}>
          <span className="absolute -left-[25px] top-1.5 h-2 w-2 rounded-full" style={{ background: "var(--brand)" }} />
          <p className="text-sm text-slate-200">{h.description}</p>
          <p className="mt-0.5 text-xs text-slate-500">{h.operator?.name}{h.operator?.email ? ` (${h.operator.email})` : ""} · {formatDateTime(h.at)}</p>
        </li>
      ))}
    </ol>
  </Panel>
);
